import { render, staticRenderFns } from "./HeaderBet.vue?vue&type=template&id=b906a42a"
import script from "./HeaderBet.vue?vue&type=script&lang=js"
export * from "./HeaderBet.vue?vue&type=script&lang=js"
import style0 from "./HeaderBet.vue?vue&type=style&index=0&id=b906a42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports